import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Loader({ onDone }) {
    const [count, setCount] = useState(0);
    const [done, setDone] = useState(false);
    useEffect(() => {
        const t = setInterval(() => {
            setCount((c) => {
                if (c >= 100) { clearInterval(t); return 100; }
                return Math.min(100, c + Math.floor(Math.random() * 9) + 3);
            });
        }, 90);
        return () => clearInterval(t);
    }, []);
    useEffect(() => {
        if (count >= 100) {
            const t = setTimeout(() => { setDone(true); onDone && onDone(); }, 500);
            return () => clearTimeout(t);
        }
    }, [count, onDone]);

    return (
        <AnimatePresence>
            {!done && (
                <motion.div
                    data-testid="preloader"
                    className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-background"
                    exit={{ y: "-100%" }}
                    transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
                >
                    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="font-display text-2xl sm:text-3xl font-medium mb-6 overflow-hidden">
                        <motion.span initial={{ y: 40 }} animate={{ y: 0 }} transition={{ duration: 0.6 }} className="inline-block">
                            Hariom Patel
                        </motion.span>
                    </motion.div>
                    <div className="w-56 h-px bg-muted overflow-hidden relative">
                        <motion.div className="absolute inset-y-0 left-0 bg-gradient-to-r from-primary to-accent" style={{ width: `${count}%` }} />
                    </div>
                    <div className="mt-4 font-mono text-xs text-muted-foreground tabular-nums">{count}%</div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
